import { cn } from '@/lib/utils';

interface ThinkingIndicatorProps {
  label?: string;
}

export const ThinkingIndicator = ({ label }: ThinkingIndicatorProps): JSX.Element => (
  <div className="flex items-center gap-2 py-1.5 pl-10" aria-live="polite">
    <div className="flex items-center gap-1.5">
      {[0, 1, 2].map((i) => (
        <span
          key={i}
          className={cn(
            'h-2 w-2 rounded-full bg-neutral-400',
            'animate-[pulse_1.2s_ease-in-out_infinite]',
            i === 1 && '[animation-delay:0.2s]',
            i === 2 && '[animation-delay:0.4s]'
          )}
        />
      ))}
    </div>
    {label && <span className="text-sm text-neutral-500 italic">{label}</span>}
  </div>
);
